import AutoRotate from './AutoRotate';

export default {
  install(Vue) {
    Vue.component('autoRotate', AutoRotate);
  }
};
